import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loaderScreen$: BehaviorSubject<{ activo: boolean, mensaje: string }> = new BehaviorSubject<{ activo: boolean, mensaje: string }>({ activo: false, mensaje: "" });
  constructor() { }

  public obtenerObsLoaderScreen(): Observable<{ activo: boolean, mensaje: string }> {
    return this.loaderScreen$.asObservable();
  }
  public activarLoaderScreen(mensaje?: string): void {
    if (mensaje) {
      this.loaderScreen$.next({ activo: true, mensaje });
    } else {
      this.loaderScreen$.next({ activo: true, mensaje: '' });
    }

  }
  public desactivarLoaderScreen(): void {
    this.loaderScreen$.next({ activo: false, mensaje: "" });
  }
}
 